import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import {
  BulkAction,
  ModalService,
  DataService,
} from "@bb-vendure/admin-ui/core";
import {
  DeleteConsentTranslationDocument,
  DeleteConsentTranslationMutation,
} from "src/generated-gql/graphql";

const deleteConsentTranslations: BulkAction = {
  location: "consent-translation-table",
  label: "Delete selected translations",
  icon: "trash",
  iconClass: "is-danger",
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    modalService
      .dialog({
        title: "Delete selected translation",
        body: `Are you sure you want to delete ${selection.length} translations?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Delete", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeleteConsentTranslationMutation>[] =
            [];
          for (const item in result) {
            deleteObservables.push(
              dataService.mutate(DeleteConsentTranslationDocument, {
                id: result[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe(() => {
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};

export { deleteConsentTranslations };
